import React, { useEffect, useState, useCallback, useRef } from 'react';
import Container from '../../Container/Container';
import { useNavigate } from 'react-router';
import { get } from '../../ApiServices/ApiServices';
import Loader from '../Component/Loader';
import CancelFun from '../Component/CancelFun';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useSelector } from 'react-redux';
import Select from 'react-select';

function SingleOrder() {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [Status, setStatus] = useState([])
    const orderDatePickerRef = useRef(null);
    const eventDatePickerRef = useRef(null);
    const weekendDatePickerRef = useRef(null);
    const profile = useSelector((state) => state.profile.profile);
    const isAdmin = profile?.name === 'admin' || profile?.name === 'Admin';
    const [customer, setCustomer] = useState([]);
    const [accountFilter, setAccountFilter] = useState("");
    const [isFiltersLoaded, setIsFiltersLoaded] = useState(false);
    const [orderDateRange, setOrderDateRange] = useState({
        startDate: null,
        endDate: null,
    });

    const [eventDateRange, setEventDateRange] = useState({
        startDate: null,
        endDate: null,
    });

    const [weekendDateRange, setWeekendDateRange] = useState({
        startDate: null,
        endDate: null,
    });

    const [orderDateDisplayLabel, setOrderDateDisplayLabel] = useState('');
    const [eventDateDisplayLabel, setEventDateDisplayLabel] = useState('');
    const [weekendDateDisplayLabel, setWeekendDateDisplayLabel] = useState('');
    useEffect(() => {
        if (isAdmin) {
            const savedFilters = sessionStorage.getItem("singleOrderFilters");

            if (savedFilters) {
                const parsed = JSON.parse(savedFilters);

                setSearch(parsed.search || "");
                setSelectedStatus(parsed.selectedStatus || "");
                setAccountFilter(parsed.accountFilter || "");
                setCurrentPage(parsed.currentPage || 1);
                setItemsPerPage(parsed.itemsPerPage || 10);

                setOrderDateRange(parsed.orderDateRange || { startDate: null, endDate: null });
                setEventDateRange(parsed.eventDateRange || { startDate: null, endDate: null });
                setWeekendDateRange(parsed.weekendDateRange || { startDate: null, endDate: null });

                setOrderDateDisplayLabel(parsed.orderDateDisplayLabel || "");
                setEventDateDisplayLabel(parsed.eventDateDisplayLabel || "");
                setWeekendDateDisplayLabel(parsed.weekendDateDisplayLabel || "");
            }
        }

        setIsFiltersLoaded(true); // 🔥 important
    }, [isAdmin]);



    useEffect(() => {
        if (isAdmin && isFiltersLoaded) {
            const filters = {
                search,
                selectedStatus,
                accountFilter,
                currentPage,
                itemsPerPage,
                orderDateRange,
                eventDateRange,
                weekendDateRange,
                orderDateDisplayLabel,
                eventDateDisplayLabel,
                weekendDateDisplayLabel
            };

            sessionStorage.setItem("singleOrderFilters", JSON.stringify(filters));
        }
    }, [
        search,
        selectedStatus,
        accountFilter,
        currentPage,
        itemsPerPage,
        orderDateRange,
        eventDateRange,
        weekendDateRange,
        orderDateDisplayLabel,
        eventDateDisplayLabel,
        weekendDateDisplayLabel,
        isAdmin,
        isFiltersLoaded
    ]);
    useEffect(() => {
        localStorage.removeItem('coatStyle');
        localStorage.removeItem('size');
        localStorage.removeItem('nonBoldMessage');
        localStorage.removeItem('selectedCoatSize');
        localStorage.removeItem('selectedCategoryName');
        localStorage.removeItem('allSize');
        localStorage.removeItem('Shoes');
        localStorage.removeItem('savedInsleeve');
        localStorage.removeItem('shirtstyle');
        localStorage.removeItem('shirtSizeRecommendationMsg');
        localStorage.removeItem('pantStyle');
        localStorage.removeItem('Tiestyle');

    }, [])




    const getCustomer = async () => {
        try {
            const api = `get-customers`;
            const response = await get(api);

            if (response?.status === true) {
                setCustomer(response?.data?.rows || []);
            }
        } catch (err) {
            if (
                err?.message === "Invalid or expired token" ||
                err?.message === "Invalid Token"
            ) {
                localStorage.removeItem("token");
                navigate("/login");
            }
            console.error("Error fetching customers:", err);
        }
    };

    const getSingleOrders = useCallback(async (
        page = 1,
        limit = 10,
        searchTerm = '',
        statusId = '',
        account = '',
        orderStartDate = null,
        orderEndDate = null,
        eventStartDate = null,
        eventEndDate = null,
        weekendStartDate = null,
        weekendEndDate = null
    ) => {
        setLoading(true);
        try {
            let apiUrl = `all-single-orders?page_number=${page}&size=${limit}`;

            if (searchTerm) apiUrl += `&search=${searchTerm}`;
            if (statusId) apiUrl += `&status_id=${statusId}`;
            if (account) apiUrl += `&account=${account}`;

            if (orderStartDate && orderEndDate) {
                apiUrl += `&order_start_date=${moment(orderStartDate).format('YYYY-MM-DD')}`;
                apiUrl += `&order_end_date=${moment(orderEndDate).format('YYYY-MM-DD')}`;
            }

            if (eventStartDate && eventEndDate) {
                apiUrl += `&start_date=${moment(eventStartDate).format('YYYY-MM-DD')}`;
                apiUrl += `&end_date=${moment(eventEndDate).format('YYYY-MM-DD')}`;
            }

            if (weekendStartDate && weekendEndDate) {
                apiUrl += `&weekend_start_date=${moment(weekendStartDate).format('YYYY-MM-DD')}`;
                apiUrl += `&weekend_end_date=${moment(weekendEndDate).format('YYYY-MM-DD')}`;
            }

            const response = await get(apiUrl);
            if (response?.status === true) {
                setOrders(response.data.rows);
                setFilteredOrders(response.data.rows);
                setTotalItems(response.data.count || response.data.rows.length);
            } else {
                setOrders([]);
                setFilteredOrders([]);
                setTotalItems(0);
            }
        } catch (err) {
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Error fetching orders:', err);
        } finally {
            setLoading(false);
        }
    }, [navigate]);

    // Handle order date range selection
    const handleOrderDateApply = (event, picker) => {
        const startDate = picker.startDate;
        const endDate = picker.endDate;

        setOrderDateRange({ startDate, endDate });
        setOrderDateDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);

        // Reset to first page when date changes
        setCurrentPage(1);

        // Fetch data with new date range
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            accountFilter,
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD'),
            eventDateRange.startDate?.format('YYYY-MM-DD'),
            eventDateRange.endDate?.format('YYYY-MM-DD'),
            weekendDateRange.startDate?.format('YYYY-MM-DD'),
            weekendDateRange.endDate?.format('YYYY-MM-DD')
        );
    };

    // Clear order date filters - FIXED
    const handleOrderDateCancel = () => {
        setOrderDateRange({ startDate: null, endDate: null });
        setOrderDateDisplayLabel('');

        // Reset to first page and fetch without order date filters
        setCurrentPage(1);
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            accountFilter,
            null,
            null,
            eventDateRange.startDate?.format('YYYY-MM-DD'),
            eventDateRange.endDate?.format('YYYY-MM-DD'),
            weekendDateRange.startDate?.format('YYYY-MM-DD'),
            weekendDateRange.endDate?.format('YYYY-MM-DD')
        );
    };

    // Handle event date range selection
    const handleEventDateApply = (event, picker) => {
        const startDate = picker.startDate;
        const endDate = picker.endDate;

        setEventDateRange({ startDate, endDate });
        setEventDateDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);

        // Reset to first page when date changes
        setCurrentPage(1);

        // Fetch data with new date range
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            accountFilter,
            orderDateRange.startDate?.format('YYYY-MM-DD'),
            orderDateRange.endDate?.format('YYYY-MM-DD'),
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD'),
            weekendDateRange.startDate?.format('YYYY-MM-DD'),
            weekendDateRange.endDate?.format('YYYY-MM-DD')
        );
    };

    // Clear event date filters - FIXED
    const handleEventDateCancel = () => {
        setEventDateRange({ startDate: null, endDate: null });
        setEventDateDisplayLabel('');

        // Reset to first page and fetch without event date filters
        setCurrentPage(1);
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            accountFilter,
            orderDateRange.startDate?.format('YYYY-MM-DD'),
            orderDateRange.endDate?.format('YYYY-MM-DD'),
            null,
            null,
            weekendDateRange.startDate?.format('YYYY-MM-DD'),
            weekendDateRange.endDate?.format('YYYY-MM-DD')
        );
    };

    // Handle weekend date range selection
    const handleWeekendDateApply = (event, picker) => {
        const startDate = picker.startDate;
        const endDate = picker.endDate;
        setWeekendDateRange({ startDate, endDate });
        setWeekendDateDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);
        setCurrentPage(1);
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            accountFilter,
            orderDateRange.startDate?.format('YYYY-MM-DD'),
            orderDateRange.endDate?.format('YYYY-MM-DD'),
            eventDateRange.startDate?.format('YYYY-MM-DD'),
            eventDateRange.endDate?.format('YYYY-MM-DD'),
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD')
        );
    };

    // Clear weekend date filters
    const handleWeekendDateCancel = () => {
        setWeekendDateRange({ startDate: null, endDate: null });
        setWeekendDateDisplayLabel('');
        setCurrentPage(1);
        getSingleOrders(
            1,
            itemsPerPage,
            search,
            selectedStatus,
            accountFilter,
            orderDateRange.startDate?.format('YYYY-MM-DD'),
            orderDateRange.endDate?.format('YYYY-MM-DD'),
            eventDateRange.startDate?.format('YYYY-MM-DD'),
            eventDateRange.endDate?.format('YYYY-MM-DD'),
            null,
            null
        );
    };

    // Handle search with debounce
    useEffect(() => {
        if (!isFiltersLoaded) return;

        const delayDebounceFn = setTimeout(() => {
            getSingleOrders(
                currentPage,
                itemsPerPage,
                search,
                selectedStatus,
                accountFilter,
                orderDateRange.startDate,
                orderDateRange.endDate,
                eventDateRange.startDate,
                eventDateRange.endDate,
                weekendDateRange.startDate,
                weekendDateRange.endDate
            );
        }, 400);

        return () => clearTimeout(delayDebounceFn);
    }, [
        currentPage,
        itemsPerPage,
        search,
        selectedStatus,
        accountFilter,
        orderDateRange,
        eventDateRange,
        weekendDateRange,
        isFiltersLoaded
    ]);

    // Initial load and pagination changes
    // useEffect(() => {
    //     getSingleOrders(
    //         currentPage,
    //         itemsPerPage,
    //         search,
    //         selectedStatus,
    //         accountFilter,
    //         orderDateRange.startDate?.format('YYYY-MM-DD'),
    //         orderDateRange.endDate?.format('YYYY-MM-DD'),
    //         eventDateRange.startDate?.format('YYYY-MM-DD'),
    //         eventDateRange.endDate?.format('YYYY-MM-DD')
    //     );
    // }, [currentPage, getSingleOrders]);

    const handleSearch = (e) => setSearch(e.target.value);
    const handlePageChange = (page) => setCurrentPage(page);
    const handleItemsPerPageChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setItemsPerPage(newLimit);
        setCurrentPage(1);
    };

    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value);
        setCurrentPage(1);
    };

    const onCancleSuccess = () => {
        getSingleOrders(
            currentPage,
            itemsPerPage,
            search,
            selectedStatus,
            accountFilter,
            orderDateRange.startDate?.format('YYYY-MM-DD'),
            orderDateRange.endDate?.format('YYYY-MM-DD'),
            eventDateRange.startDate?.format('YYYY-MM-DD'),
            eventDateRange.endDate?.format('YYYY-MM-DD'),
            weekendDateRange.startDate?.format('YYYY-MM-DD'),
            weekendDateRange.endDate?.format('YYYY-MM-DD')
        );
    };

    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const getItemByCategory = (order, categoryName) =>
        order.single_order_style?.find(
            (item) => item.inventory_category?.name === categoryName
        );


    const ActiveStatus = async () => {
        try {
            setLoading(true)
            const api = `get-statuses`;
            const response = await get(api);
            if (response?.message === "success") {
                setStatus(response?.data)
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
        }
    };

    useEffect(() => {
        ActiveStatus()
        getCustomer();
    }, [])


    // Sort orders by event_date (latest first)
    const sortedOrders = [...orders].sort(
        (a, b) => new Date(a.event_date) - new Date(b.event_date)
    );

    // Group by event_date
    const groupedOrders = sortedOrders.reduce((acc, order) => {
        const date = moment(order.event_date).format("YYYY-MM-DD");

        if (!acc[date]) {
            acc[date] = [];
        }

        acc[date].push(order);
        return acc;
    }, {});

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">Single Orders</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                        <div className="toggle-wrap nk-block-tools-toggle">
                                            <div className="toggle-expand-content" data-content="pageMenu">
                                                <ul className="nk-block-tools g-3">
                                                    <li className="nk-block-tools-opt">
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => navigate("/add-order", { state: { Helper: true } })}
                                                        >
                                                            <span>Add Single Order</span>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full WeddingPagesMain">
                                <div className="card-inner">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-control-wrap customrSearch">
                                                <label style={{ fontWeight: 'bold' }}></label>
                                                <div className="form-icon form-icon-right">
                                                    <em className="icon ni ni-search"></em>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by keywords"
                                                    value={search}
                                                    onChange={handleSearch}
                                                    style={{
                                                        minWidth: '100%',
                                                        border: '1px solid #dbdfea',
                                                        color: '#35495e',
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-control-wrap">
                                                <label style={{ fontWeight: 'bold' }}>
                                                    Event Date
                                                </label>
                                                <DateRangePicker
                                                    ref={orderDatePickerRef}
                                                    initialSettings={{
                                                        startDate: orderDateRange.startDate || moment(),
                                                        endDate: orderDateRange.endDate || moment(),
                                                        locale: {
                                                            format: 'MMM D, YYYY',
                                                            cancelLabel: 'Clear',
                                                            applyLabel: 'Apply',
                                                        },
                                                        ranges: {
                                                            'Today': [moment(), moment()],
                                                            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                                        },
                                                        opens: 'right',
                                                        autoApply: true,
                                                        autoUpdateInput: true,
                                                        alwaysShowCalendars: true,
                                                        showCustomRangeLabel: true,
                                                        showCancel: true,
                                                    }}
                                                    onApply={handleOrderDateApply}
                                                    onCancel={handleOrderDateCancel}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control order-date-input"
                                                        placeholder="Select date range"
                                                        value={orderDateDisplayLabel}
                                                        readOnly
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: '#fff',
                                                            border: '1px solid #dbdfea',
                                                            borderRadius: '4px',
                                                            padding: '0.375rem 0.75rem',
                                                            minWidth: '100%',
                                                            paddingRight: '30px',
                                                            color: '#35495e',
                                                        }}
                                                    />
                                                </DateRangePicker>
                                                {orderDateDisplayLabel && (
                                                    <span
                                                        className="clear-icon order-date-clear"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            handleOrderDateCancel();
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '70%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer',
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        <em className="icon ni ni-cross"></em>
                                                    </span>
                                                )}
                                            </div>
                                        </div>


                                        <div className="col-md-2 stateSelect">
                                            <div className="form-control-wrap">
                                                <label style={{ fontWeight: 'bold' }}>
                                                    Order Date

                                                </label>
                                                <DateRangePicker
                                                    ref={eventDatePickerRef}
                                                    initialSettings={{
                                                        startDate: eventDateRange.startDate || moment(),
                                                        endDate: eventDateRange.endDate || moment(),
                                                        locale: {
                                                            format: 'MMM D, YYYY',
                                                            cancelLabel: 'Clear',
                                                            applyLabel: 'Apply',
                                                        },
                                                        ranges: {
                                                            'Today': [moment(), moment()],
                                                            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                                        },
                                                        opens: 'right',
                                                        autoApply: true,
                                                        autoUpdateInput: true,
                                                        alwaysShowCalendars: true,
                                                        showCustomRangeLabel: true,
                                                        showCancel: true,
                                                    }}
                                                    onApply={handleEventDateApply}
                                                    onCancel={handleEventDateCancel}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control event-date-input"
                                                        placeholder="Select date range"
                                                        value={eventDateDisplayLabel}
                                                        readOnly
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: '#fff',
                                                            border: '1px solid #dbdfea',
                                                            borderRadius: '4px',
                                                            padding: '0.375rem 0.75rem',
                                                            minWidth: '100%',
                                                            paddingRight: '30px',
                                                            color: '#35495e',
                                                        }}
                                                    />
                                                </DateRangePicker>
                                                {eventDateDisplayLabel && (
                                                    <span
                                                        className="clear-icon event-date-clear"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            handleEventDateCancel();
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '70%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer',
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        <em className="icon ni ni-cross"></em>
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* <div className="col-md-2">
                                            <div className="form-control-wrap">
                                                <label style={{ fontWeight: 'bold' }}>
                                                    Weekend Date
                                                </label>
                                                <DateRangePicker
                                                    ref={weekendDatePickerRef}
                                                    initialSettings={{
                                                        startDate: weekendDateRange.startDate || moment(),
                                                        endDate: weekendDateRange.endDate || moment(),
                                                        locale: {
                                                            format: 'MMM D, YYYY',
                                                            cancelLabel: 'Clear',
                                                            applyLabel: 'Apply',
                                                        },
                                                        ranges: {
                                                            'Today': [moment(), moment()],
                                                            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                                        },
                                                        opens: 'right',
                                                        autoApply: true,
                                                        autoUpdateInput: true,
                                                        alwaysShowCalendars: true,
                                                        showCustomRangeLabel: true,
                                                        showCancel: true,
                                                    }}
                                                    onApply={handleWeekendDateApply}
                                                    onCancel={handleWeekendDateCancel}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Select date range"
                                                        value={weekendDateDisplayLabel}
                                                        readOnly
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: '#fff',
                                                            border: '1px solid #dbdfea',
                                                            borderRadius: '4px',
                                                            padding: '0.375rem 0.75rem',
                                                            minWidth: '100%',
                                                            paddingRight: '30px',
                                                            color: '#35495e',
                                                        }}
                                                    />
                                                </DateRangePicker>
                                                {weekendDateDisplayLabel && (
                                                    <span
                                                        className="clear-icon"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            handleWeekendDateCancel();
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '70%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer',
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        <em className="icon ni ni-cross"></em>
                                                    </span>
                                                )}
                                            </div>
                                        </div> */}

                                        <div className="col-md-2 stateSelect">
                                            <div className="form-control-wrap">
                                                <label style={{ fontWeight: 'bold' }}>
                                                    Order Status
                                                </label>
                                                <Select
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    placeholder="Filter by Active Status"
                                                    isClearable
                                                    maxMenuHeight={280}
                                                    menuPlacement="auto"
                                                    menuPosition="fixed"
                                                    menuPortalTarget={document.body}
                                                    options={[
                                                        { value: "", label: "All" },
                                                        ...Status.map((data) => ({
                                                            value: data.id,
                                                            label: data.name
                                                        }))
                                                    ]}
                                                    value={
                                                        selectedStatus
                                                            ? Status.map((data) => ({
                                                                value: data.id,
                                                                label: data.name
                                                            })).find((opt) => opt.value === selectedStatus)
                                                            : null
                                                    }
                                                    onChange={(selectedOption) => {
                                                        setSelectedStatus(selectedOption?.value || "");
                                                    }}

                                                />
                                            </div>
                                        </div>
                                        {
                                            isAdmin &&
                                            <div className="col-md-2 stateSelect">
                                                <div className="form-control-wrap">
                                                    <label style={{ fontWeight: 'bold' }}>
                                                        Filter by Account
                                                    </label>

                                                    <Select
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Filter by Account"
                                                        isClearable
                                                        maxMenuHeight={280}
                                                        menuPlacement="auto"
                                                        menuPosition="fixed"
                                                        menuPortalTarget={document.body}
                                                        options={customer.map((item) => ({
                                                            value: item.account,
                                                            label: `${item.account} ${item.companyName ? `- ${item.companyName}` : ''
                                                                }`
                                                        }))}
                                                        value={
                                                            accountFilter
                                                                ? {
                                                                    value: accountFilter,
                                                                    label: accountFilter
                                                                }
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            setAccountFilter(selectedOption?.value || "");
                                                            setCurrentPage(1);
                                                        }}

                                                    />
                                                </div>
                                            </div>
                                        }

                                    </div>


                                    {loading ? (
                                        <Loader />
                                    ) : orders.length > 0 ? (
                                        <div className="table-responsive">
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Action</th>
                                                        <th scope="col">Acct</th>
                                                        <th scope="col">Ticket</th>
                                                        <th scope="col">Event Date</th>
                                                        <th scope="col">Customer Name</th>
                                                        <th scope="col">Order Date</th>
                                                        <th scope="col">Order Type</th>
                                                        <th scope="col">School Name</th>
                                                        <th scope="col">Order Status</th>
                                                        <th scope="col">Coat</th>
                                                        <th scope="col">Pant</th>
                                                        <th scope="col">Shirt</th>
                                                        <th scope="col">Vest </th>
                                                        <th scope="col">Tie</th>
                                                        <th scope="col">Shoes</th>
                                                        <th scope="col">Pocket Square</th>
                                                        <th scope="col">Jewelry</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* {orders.map((order, index) => { */}
                                                    {Object.entries(groupedOrders).map(([date, ordersByDate]) => (
                                                        <React.Fragment key={date}>

                                                            {/* Event Date Header Row */}
                                                            <tr style={{ backgroundColor: "#f5f6fa" }}>
                                                                <td colSpan="17" style={{ fontWeight: "bold", fontSize: "15px" }}>
                                                                    {moment(date).format("MMM D, YYYY")}
                                                                </td>
                                                            </tr>

                                                            {ordersByDate.map((order, index) => {
                                                                const coatItem = getItemByCategory(order, "Coats");
                                                                const shirtItem = getItemByCategory(order, "Shirt");
                                                                const pantsItem = getItemByCategory(order, "Pants");
                                                                const tieItem = getItemByCategory(order, "Ties");
                                                                const jewelryItem = getItemByCategory(order, "Jewelry");
                                                                const vestItem = getItemByCategory(order, "Vests");
                                                                const shoeItem = getItemByCategory(order, "Shoes");
                                                                const pocketSquareItem = getItemByCategory(order, "PocketSquare");
                                                                const disallowedStatuses = [
                                                                    'cancelled',
                                                                    'pendingCancel',
                                                                    'cancelRequested',
                                                                    'pendingChange',
                                                                    'shipped',
                                                                    'printed',
                                                                    'bagged',
                                                                    'notReturned',
                                                                    'returned',
                                                                ];

                                                                // Disable ordered only for NON-CSV orders
                                                                const isOrderedDisabled =
                                                                    order?.status?.name === 'ordered' && !order?.is_csv;

                                                                const isEditDisabled =
                                                                    (order?.order_type === "T" && !isAdmin) ||
                                                                    disallowedStatuses.includes(order?.status?.name) ||
                                                                    isOrderedDisabled ||
                                                                    order?.user?.deletedAt;
                                                                return (
                                                                    <tr key={order.id}>
                                                                        <td>
                                                                            <div className="tableActionBtn-1" style={{ cursor: "pointer" }}>
                                                                                <div className="tooltip-container" style={{ position: 'relative', display: 'inline-block' }}>
                                                                                    <button
                                                                                        className="editPen"
                                                                                        onClick={() => {
                                                                                            // const disallowedStatuses = ['cancelled', 'pendingCancel', 'cancelRequested', 'pendingChange', 'shipped', 'printed', 'bagged', 'notReturned', 'returned', 'ordered'];
                                                                                            // if (!disallowedStatuses.includes(order?.status?.name) &&
                                                                                            //     (isAdmin || order?.order_type !== "T")) {
                                                                                            //     navigate(`/update-single-order`, {
                                                                                            //         state: { ID: order.id, Helper: false }
                                                                                            //     });
                                                                                            // }
                                                                                            if (!isEditDisabled) {
                                                                                                navigate(`/update-single-order`, {
                                                                                                    state: { ID: order.id, Helper: false }
                                                                                                });
                                                                                            }
                                                                                        }}

                                                                                        // style={(order?.order_type === "T" && !isAdmin) || order?.status?.name == 'cancelled' || order?.status?.name == 'pendingCancel' || order?.status?.name == "pendingChange" || order?.status?.name == "cancelRequested" || order?.status?.name == "shipped" || order?.status?.name == "printed" || order?.status?.name == "bagged" || order?.status?.name == "returned" || order?.status?.name == "notReturned" || order?.status?.name == "ordered" || order?.user?.deletedAt
                                                                                        //     ? { opacity: 0.5, cursor: 'not-allowed' }
                                                                                        //     : {}}
                                                                                        style={
                                                                                            isEditDisabled
                                                                                                ? { opacity: 0.5, cursor: 'not-allowed' }
                                                                                                : {}
                                                                                        }
                                                                                    >
                                                                                        <em className="icon ni ni-edit-alt"></em>
                                                                                    </button>

                                                                                    {order?.user?.deletedAt && (
                                                                                        <div
                                                                                            className="tooltip"
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                bottom: '100%',
                                                                                                left: '130%',
                                                                                                transform: 'translateX(-50%)',
                                                                                                backgroundColor: '#333',
                                                                                                color: 'white',
                                                                                                padding: '5px 8px',
                                                                                                borderRadius: '4px',
                                                                                                fontSize: '12px',
                                                                                                whiteSpace: 'nowrap',
                                                                                                opacity: 0,
                                                                                                visibility: 'hidden',
                                                                                                transition: 'opacity 0.3s, visibility 0.3s',
                                                                                                zIndex: 1000,
                                                                                                marginBottom: '5px'
                                                                                            }}
                                                                                            onMouseEnter={(e) => {
                                                                                                e.currentTarget.style.opacity = '1';
                                                                                                e.currentTarget.style.visibility = 'visible';
                                                                                            }}
                                                                                            onMouseLeave={(e) => {
                                                                                                e.currentTarget.style.opacity = '0';
                                                                                                e.currentTarget.style.visibility = 'hidden';
                                                                                            }}
                                                                                        >
                                                                                            Account removed
                                                                                            <div style={{
                                                                                                position: 'absolute',
                                                                                                top: '100%',
                                                                                                left: '20%',
                                                                                                transform: 'translateX(-50%)',
                                                                                                border: '5px solid transparent',
                                                                                                borderTopColor: '#333'
                                                                                            }}></div>
                                                                                        </div>
                                                                                    )}

                                                                                    <style jsx>{`
        .tooltip-container:hover .tooltip {
            opacity: 1 !important;
            visibility: visible !important;
        }
    `}</style>
                                                                                </div>
                                                                                <button
                                                                                    className="deleteTrash"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => navigate('/order-detail', { state: { orderId: order?.id } })}
                                                                                >
                                                                                    <em className="icon ni ni-eye"></em>
                                                                                </button>

                                                                                {(isAdmin || order?.order_type !== "T") && !['cancelled', 'pendingCancel', 'cancelRequested', 'pendingChange', 'shipped', 'printed', 'bagged', 'notReturned', 'returned'].includes(order?.status?.name) && (
                                                                                    <CancelFun
                                                                                        url={`confirm-single-order/${order.id}`}
                                                                                        onCancleSuccess={onCancleSuccess}
                                                                                        status={order?.status?.name == "ordered" ? 11 : null}
                                                                                        requestedByUserId={
                                                                                            profile?.name === "Admin"
                                                                                                ? profile?.id           // Admin cancel
                                                                                                : order?.user_id        // ✅ Customer cancel (198)
                                                                                        }
                                                                                    />
                                                                                )}

                                                                            </div>
                                                                        </td>
                                                                        <td>{order?.user?.account || "---"}</td>
                                                                        <td>{order?.ticket || "---"}</td>
                                                                        <td className="tableMinWidth120">{moment.utc(order?.event_date).format("MMM D, YYYY")}</td>
                                                                        <td>{`${order.first_name || ""} ${order.last_name || ""}`.trim() || "---"}</td>
                                                                        <td className="tableMinWidth120">{moment.utc(order?.is_csv ? order?.order_creation : order?.createdAt).format("MMM D, YYYY")}</td>
                                                                        <td className="tableMinWidth120">{order?.order_type === "T" ? order?.occasion || "---" : order?.order_type || "---"}</td>
                                                                        <td>{order?.school || "---"}</td>
                                                                        <td style={{ textTransform: 'capitalize' }}>{order?.status?.name || "---"}</td>
                                                                        <td data-tooltip-id={`coat-tooltip-${index}`} data-tooltip-content={coatItem?.inventory?.description && `${coatItem?.inventory?.description || ''} , ${coatItem?.size || "Missing size"}${coatItem?.size && coatItem?.size_chart_category?.name
                                                                            ? coatItem.size_chart_category.name === "Short"
                                                                                ? "S"
                                                                                : coatItem.size_chart_category.name === "Long"
                                                                                    ? "L"
                                                                                    : coatItem.size_chart_category.name === "Extra Long"
                                                                                        ? "X"
                                                                                        : coatItem.size_chart_category.name === "Regular"
                                                                                            ? "R"
                                                                                            : coatItem.size_chart_category.name === "Boys"
                                                                                                ? "B"
                                                                                                : "N/A"
                                                                            : ""}`} style={{ cursor: "pointer" }}>
                                                                            {coatItem?.style || "---"}
                                                                            <ReactTooltip id={`coat-tooltip-${index}`} />
                                                                        </td>
                                                                        <td data-tooltip-id={`pants-tooltip-${index}`} data-tooltip-content={pantsItem?.inventory?.description && `${pantsItem?.inventory?.description || ''} , ${pantsItem?.size || "Missing size"}`} style={{ cursor: "pointer" }}>
                                                                            {pantsItem?.style || "---"}
                                                                            <ReactTooltip id={`pants-tooltip-${index}`} />
                                                                        </td>
                                                                        <td data-tooltip-id={`shirt-tooltip-${index}`} data-tooltip-content={shirtItem?.inventory?.description && `${shirtItem?.inventory?.description || ''} , ${shirtItem?.shirt_size || "Missing size"}`} style={{ cursor: "pointer" }}>
                                                                            {shirtItem?.style || "---"}
                                                                            <ReactTooltip id={`shirt-tooltip-${index}`} />
                                                                        </td>
                                                                        <td data-tooltip-id={`vest-tooltip-${index}`} data-tooltip-content={vestItem?.inventory?.description && `${vestItem?.inventory?.description || ''} , ${vestItem?.size || "Missing size"}`} style={{ cursor: "pointer" }}>
                                                                            {vestItem?.style || "---"}
                                                                            <ReactTooltip id={`vest-tooltip-${index}`} />
                                                                        </td>
                                                                        <td data-tooltip-id={`tie-tooltip-${index}`} data-tooltip-content={tieItem?.inventory?.description && `${tieItem?.inventory?.description || ''} , ${order?.order_for || 'Missing size'} `} style={{ cursor: "pointer" }}>
                                                                            {tieItem?.style || "---"}
                                                                            <ReactTooltip id={`tie-tooltip-${index}`} />
                                                                        </td>
                                                                        <td data-tooltip-id={`shoe-tooltip-${index}`} data-tooltip-content={shoeItem?.inventory?.description && `${shoeItem?.inventory?.description || ''}, ${shoeItem?.inventory?.description ? shoeItem?.size || 'Missing size' : ''}`} style={{ cursor: "pointer" }}>
                                                                            {shoeItem?.style || "---"}
                                                                            <ReactTooltip id={`shoe-tooltip-${index}`} />
                                                                        </td>
                                                                        <td data-tooltip-id="pocket-square-tooltip" data-tooltip-content={pocketSquareItem?.inventory?.description || ''} style={{ cursor: "pointer" }}>
                                                                            {pocketSquareItem?.style || "---"}
                                                                            <ReactTooltip id="pocket-square-tooltip" />
                                                                        </td>
                                                                        <td data-tooltip-id="jewelry-tooltip" data-tooltip-content={jewelryItem?.inventory?.description || ''} style={{ cursor: "pointer" }}>
                                                                            {jewelryItem?.style || "---"}
                                                                            <ReactTooltip id="jewelry-tooltip" />
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="text-center">No data available</div>
                                    )}

                                    {/* Pagination */}
                                    {filteredOrders.length > 0 && (
                                        <div className="nk-block-between-md g-3 mt-3">
                                            <div className="g">
                                                <div className="pagination d-flex gap-2" style={{ height: "35px" }}>
                                                    <button
                                                        className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                    >
                                                        Previous
                                                    </button>

                                                    {Array.from({ length: totalPages }, (_, i) => (
                                                        <button
                                                            key={i + 1}
                                                            className={`btn btn-sm ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                                                            onClick={() => handlePageChange(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </button>
                                                    )).slice(
                                                        Math.max(0, currentPage - 3),
                                                        Math.min(currentPage + 2, totalPages)
                                                    )}

                                                    <button
                                                        className={`btn btn-sm ${currentPage === totalPages ? 'btn-disabled' : 'btn-primary'}`}
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>

                                            {filteredOrders.length >= 10 && (
                                                <div className="g">
                                                    <div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
                                                        <div>Showing</div>
                                                        <div>
                                                            <select
                                                                className="form-select js-select2"
                                                                value={itemsPerPage}
                                                                onChange={handleItemsPerPageChange}
                                                            >
                                                                {totalItems >= 10 && <option value="10">10</option>}
                                                                {totalItems >= 20 && <option value="20">20</option>}
                                                                {totalItems >= 50 && <option value="50">50</option>}
                                                                {totalItems >= 100 && <option value="100">100</option>}
                                                            </select>
                                                        </div>
                                                        <div>of {totalItems} items</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default SingleOrder;